// extracted by mini-css-extract-plugin
export default {"instruction":"UpdatePartnerOrgsModal_instruction__lMCCJ","updateBtn":"UpdatePartnerOrgsModal_updateBtn__73ZhE"};